import { useState } from "react";
import { Container } from "react-bootstrap";
import FreelancerserplaceNavbar from "../../signup/SubComponents/FreelancerserplaceNavbar";
import RegisterModal from "../../signup/RegisterModal";
import Footer from "../../signup/SubComponents/Footer";
import { MockBillingDashboard } from "./Components/MockScreens";

const BillingLandingpage = () => {
  const [showRegister, setShowRegister] = useState(false);

  const features = [
    {
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/>
        </svg>
      ),
      title: "Outgoing Invoices",
      text: "Create professional invoices and offers in seconds. Track payment status and send reminders automatically.",
    },
    {
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
        </svg>
      ),
      title: "Incoming Bills",
      text: "Track what you owe and when it's due. Keep all incoming bills organised in one place.",
    },
    {
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="1" y="4" width="22" height="16" rx="2" ry="2"/><line x1="1" y1="10" x2="23" y2="10"/>
        </svg>
      ),
      title: "Payment Tracking",
      text: "Know which invoices are paid, overdue, or pending at a glance. No more chasing spreadsheets.",
    },
    {
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
        </svg>
      ),
      title: "Financial Overview",
      text: "Get a clear summary of your income and expenses. Understand your cash flow without an accountant.",
    },
  ];

  return (
    <>
      <RegisterModal show={showRegister} setShow={setShowRegister} showLoginForm={false} />
      <FreelancerserplaceNavbar />

      {/* Hero */}
      <div className="lp-hero-bg">
        <Container>
          <div style={{
            display: "grid", gridTemplateColumns: "1fr 1fr",
            gap: "3rem", alignItems: "center",
            paddingTop: "5rem", paddingBottom: "5rem",
            position: "relative",
          }}>
            <div className="yellowdotWelcome" />
            <div className="greendotWelcome" />
            <div>
              <div className="lp-badge">Billing</div>
              <h1 className="lp-hero-title">
                Invoice, track and get <span style={{ color: "#007BFF" }}>paid faster</span>
              </h1>
              <p className="lp-hero-subtitle">
                Stop juggling spreadsheets and chasing payments.
                FreelancersPlace handles your incoming and outgoing bills so you can focus on the work that actually pays.
              </p>
              <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap", alignItems: "center" }}>
                <button className="lp-cta-btn btn btn-primary" onClick={() => setShowRegister(true)}>
                  Try now for free
                </button>
                <a href="https://demo.freelancersplace.net" target="_blank" rel="noreferrer" className="lp-demo-link">
                  View demo →
                </a>
              </div>
              <div className="lp-trust-badges">
                <span>✓ 30-day free trial</span>
                <span>✓ No credit card required</span>
              </div>
            </div>

            <div>
              <div className="reddotWelcome" />
              <MockBillingDashboard />
            </div>
          </div>
        </Container>
      </div>

      {/* Feature grid */}
      <div className="lp-section-alt">
        <Container>
          <div style={{ paddingTop: "4rem", paddingBottom: "4rem" }}>
            <div style={{ textAlign: "center", marginBottom: "3rem" }}>
              <span className="blueSubheaderTop">Everything you need</span>
              <h2 className="landingpageHeader" style={{ fontWeight: 400, marginTop: "0.5rem" }}>
                All your billing in one place
              </h2>
            </div>
            <div style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
              gap: "1.25rem",
            }}>
              {features.map(({ icon, title, text }) => (
                <div key={title} style={{
                  background: "#fff",
                  border: "1px solid #e8edf5",
                  borderRadius: "1rem",
                  padding: "1.5rem",
                  transition: "box-shadow 0.15s, transform 0.15s",
                }}
                  onMouseOver={e => { e.currentTarget.style.boxShadow = "0 8px 32px rgba(0,0,0,0.1)"; e.currentTarget.style.transform = "translateY(-2px)"; }}
                  onMouseOut={e => { e.currentTarget.style.boxShadow = "none"; e.currentTarget.style.transform = "none"; }}
                >
                  <div style={{
                    width: "44px", height: "44px", borderRadius: "10px",
                    background: "#e8f1ff", display: "flex", alignItems: "center",
                    justifyContent: "center", color: "#007BFF", marginBottom: "1rem",
                  }}>
                    {icon}
                  </div>
                  <h4 style={{ fontFamily: "'Space Grotesk', sans-serif", fontWeight: 700, fontSize: "1rem", marginBottom: "0.5rem" }}>
                    {title}
                  </h4>
                  <p className="landingpageDescriptions" style={{ marginBottom: 0 }}>{text}</p>
                </div>
              ))}
            </div>
          </div>
        </Container>
      </div>

      {/* Coming soon AI strip */}
      <Container fluid>
        <div className="opacity-bg" style={{ minHeight: "unset", paddingTop: "1.5rem", paddingBottom: "1.5rem", textAlign: "center" }}>
          <span style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: "1rem", opacity: 0.9 }}>
            🤖 <strong>Coming soon:</strong> AI-powered data extraction from bills — automatically grow your contact list
          </span>
        </div>
      </Container>

      {/* CTA */}
      <Container>
        <div style={{
          textAlign: "center", padding: "5rem 1rem",
          borderBottom: "1px solid #f0f0f0",
        }}>
          <h2 className="landingpageHeader" style={{ fontWeight: 400 }}>
            Ready to take control of your billing?
          </h2>
          <p className="landingpageDescriptions" style={{ maxWidth: "480px", margin: "0 auto 2rem" }}>
            Join freelancers who use FreelancersPlace to stay on top of their finances — from the first invoice to the final payment.
          </p>
          <button className="lp-cta-btn btn btn-primary" onClick={() => setShowRegister(true)}>
            Start free trial
          </button>
        </div>
      </Container>

      <Footer />
    </>
  );
};

export default BillingLandingpage;
